import { useId } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { PageLayout } from '@interxfi/app-components/components/layout/page-layout/page-layout';
import { HorizontalStack } from '@interxfi/design-system/components/alignment/horizontal-stack';
import { buildDatePickerButtonRenderer } from '@interxfi/design-system/components/input/date-picker-input/activators/button/date-picker-button-activator';
import { DatePickerInput } from '@interxfi/design-system/components/input/date-picker-input/date-picker-input';
import { useDateAfterTodayDeterminer } from '@interxfi/design-system/components/input/date-picker-input/util';
import { PageTabRail } from '../../../../../../../../../components/page-tab-rail/page-tab-rail';
import { type PortalTabbedNavigationTab, TabbedNavigationGroup } from '../../../../../../../../../components/router/router-tabbed-navigation';
import {
  RaglCustomerStockRecordTable,
  type RaglCustomerStockRecordTableHeaderProps,
} from '../../../../../../../../../features/clearing-ledger/customer-stock-record/ragl-customer-stock-record-table';
import { getPageHead } from '../../../../../../../../../util/routing/meta';

export const Route = createFileRoute(
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/customer-stock-record/_customer-stock-record/',
)({
  staticData: {
    tab: {
      group: TabbedNavigationGroup.ClearingOperationsCore,
      label: 'Customer Stock Record',
      order: 1,
    },
  } satisfies PortalTabbedNavigationTab<TabbedNavigationGroup.ClearingOperationsCore>,
  head: () => getPageHead('Customer Stock Record'),
  component: CustomerStockRecord,
});

const DatePickerActivatorRenderer = buildDatePickerButtonRenderer('en-US', {
  day: 'numeric',
  month: 'long',
  year: 'numeric',
});

function TableHeader({ asOf, filter, onAsOfChange }: RaglCustomerStockRecordTableHeaderProps) {
  const id = useId();
  const dateAvailabilityDeterminer = useDateAfterTodayDeterminer();

  return (
    <PageTabRail
      actions={
        <HorizontalStack blockAlign="center" gap={2} wrap="nowrap">
          <DatePickerInput
            Activator={DatePickerActivatorRenderer}
            dateAvailabilityDeterminer={dateAvailabilityDeterminer}
            label="Select Date"
            name={`${id}-as-of-date`}
            onChange={(e) => onAsOfChange(e.target.value)}
            value={asOf}
          />
          {filter}
        </HorizontalStack>
      }
      group={TabbedNavigationGroup.ClearingOperationsCore}
    />
  );
}

function CustomerStockRecord() {
  return (
    <PageLayout>
      <PageLayout.Section noBorder>
        <RaglCustomerStockRecordTable HeaderActions={TableHeader} />
      </PageLayout.Section>
    </PageLayout>
  );
}
